<template>
	<v-container>
		<v-card class="shadowCard">
			<v-card-title primary-title>
			  <span class="text-caption">Datos personales</span>
			</v-card-title>
			<v-card-text>
			  
				<v-form
			    ref="form"
			    v-model="valid"
			    lazy-validation
			  >
			  	<v-row>
			  		<v-col cols="12" class="pb-0 px-4">
					    <v-text-field
					    	:disabled="disabled"
					      v-model="perfil.nombre"
					      :rules="[rules.required]"
					      label="Nombre"
					      required
					      rounded
					      filled
					      color="primary"
					      hide-details
					    ></v-text-field>
			  		</v-col>

			  		<v-col cols="12" class="pb-0">
					    <v-text-field
					    	:disabled="disabled"
					      v-model="perfil.apellido_paterno"
					      :rules="[rules.required]"
					      label="Apellido paterno"
					      required
					      rounded
					      filled
					      color="primary"
					      hide-details
					    ></v-text-field>
						</v-col>

						<v-col cols="12" class="pb-0">
					    <v-text-field
					    	:disabled="disabled"
					      v-model="perfil.apellido_materno"
					      label="Apellido materno"
					      rounded
					      filled
					      color="primary"
					      hide-details
					    ></v-text-field>
						</v-col>

						<v-col cols="6"  class="pb-0">
					    <v-text-field
					    	:disabled="disabled"
					      v-model="perfil.edad"
					      :rules="[rules.required]"
					      label="Edad"
					      required
					      rounded
					      filled
					      color="primary"
					      hide-details
					    ></v-text-field>
						</v-col>

						<v-col cols="6"  class="pb-0">
							<v-select
					    	:disabled="disabled"
					    	:items="[{id:0,sexo:'Hombre'}, {id:1,sexo:'Mujer'}]"
					      v-model="perfil.sexo"
					      label="Sexo"
					      item-text="sexo"
					      item-value="id"
					      rounded
					      filled
					      color="primary"
					      hide-details
					    ></v-select>
						</v-col>

						<v-col cols="6" class="pb-0">
							<v-text-field
					    	:disabled="disabled"
					      v-model="perfil.telefono"
					      :rules="[rules.required]"
					      label="Teléfono"
					      required
					      rounded
					      filled
					      color="primary"
					      hide-details
					    ></v-text-field>
						</v-col>

						<v-col cols="6" class="pb-0">
							<v-text-field
					    	:disabled="disabled"
					      v-model="perfil.celular"
					      :rules="[rules.required]"
					      label="Celular"
					      required
					      rounded
					      filled
					      color="primary"
					      hide-details
					    ></v-text-field>
						</v-col>
			  	</v-row>
			  </v-form>
			</v-card-text>

		  <v-card-actions class="mt-4">
		    <v-spacer></v-spacer>
		    <v-btn
		    	v-if="modoVista == 1"
		      color="primary"
		      class="text-capitalize px-6"
		      @click="disabled = false, modoVista = 2"
		      rounded
		    >
		      Editar
		    </v-btn>

		    <v-btn
		    	v-else
		      color="primary"
		      class="text-capitalize px-6"
		      @click="validarUsuario()"
		      rounded
		    >
		      Guardar
		    </v-btn>
		  </v-card-actions>
		</v-card>

		<Alerta   v-if="respuestaAlerta" :parametros="parametros"/>
    <Loader        v-if="cargar"    :loader="loader"/>

	</v-container>
</template>
<script>
	import { mapActions, mapGetters } from 'vuex'
	// Dependencias
  const md5     = require('md5')

  // Componentes
  import Alerta          from '@/components/alertas/Alerta.vue'
  import Loader          from '@/components/alertas/Loader.vue'

  // Mixins
  import  validarErrores from '@/mixins/validarErrores.js';

  export default {
  	components:{
  		Alerta,
  		Loader
  	},

  	mixins:[validarErrores],

  	props:[
			'perfil'
	  ],

    data: () => ({
    	modoVista: 1, // 1-. Editar, 2-. Guardar
    	disabled: true,
      valid: true,
    	
    	// Datos del usuario
    	usuario:'',
    	password:'',

      showPassword: true,
      rules: {
        required: value => !!value || 'Requerido.'
      },

      respuestaAlerta: false,
      success:false,
      parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},

     	loader: true,
      cargar: false,
    }),

    computed:{
    	...mapGetters( 'login', [ 'getUsuarioLMS', 'getDatosUsuarioLMS']),

    },

    methods: {
    	...mapActions( 'login', [ 'grabarUsuario', 'grabarDatosUsuario' ]),

      validarDatos () {
        return this.$refs.form.validate()
      },

      validarUsuario (){
      	this.cargar = true
      	if( this.validarDatos() ){
      		// validar los datos del usuario
      		const payload = {
	      		usuario: this.usuario,
	      		password: md5(this.password)
	      	}

	      	this.$http.post('usuario.update.datos', this.perfil).then( response => {
	      		this.grabarDatosUsuario(response.body.data)
	      		this.cargar = false
	      		this.parametros.mensaje = response.body.message
      			this.parametros.dialogError  = true
      			this.parametros.color = 'success' 
      			this.respuestaAlerta = true 
      			this.disabled  = true
      			this.modoVista = 1
	      	}).catch( error => {
	      		this.cargar = false
	      		if( error.status == 400 || error.status == 500){
	      			this.parametros.mensaje = error.body.message
	      			this.parametros.dialogError  = true 
	      			this.parametros.color = '#FF2C2C'
	      			this.respuestaAlerta = true 
	      		}
	      	}).finally(()=>{ this.cargar = false })
      	}
      },
    },
  }
</script>
<style scoped>
	.shadowCard{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.15)  !important;
	}

</style>